import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RoomRule } from '@spike/room-model';
import clsx from 'clsx';
import CounterField from 'components/UI/V3/CounterField/CounterField';
import DescriptionText from 'components/UI/V3/DescriptionText';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import { FunctionComponent } from 'react';
import styles from './TotalCountRule.module.scss';

interface TotalCountRuleProps {
    rule: RoomRule;
    onChange: (rule: RoomRule) => void;
    onDelete?: () => void;
    className?: string;
}

export const TotalCountRule: FunctionComponent<TotalCountRuleProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.row}>
                <Label>Rule – By Total Count</Label>
                <FontAwesomeIcon
                    icon={faTrashAlt}
                    onClick={props.onDelete}
                    className={styles.deleteIcon}
                />
            </div>
            <DescriptionText
                className={styles.description}
                text="Set the maximum number of pets allowed in the space at one time, regardless of size or weight."
            />
            <Label className={styles.counterLabel}>Max # of Pets</Label>
            <CounterField
                value={JSON.parse(props.rule.data).quantity}
                onChange={quantity => quantity && props.onChange({ ...props.rule, data: JSON.stringify({ quantity }) })}
                minLimit={1}
                maxLimit={999}
                hasBorder={true}
                className={styles.counter}
            />
        </div>
    );
};

export default TotalCountRule;
